import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { InfoTecnicaBienMueble } from 'app/models/info-tecnica-bien-mueble.model';
import { DetalleBienCulturalService } from '../../detalle-bien-cultural.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from 'app/modules/utils-service';
import { Observable, Subscription } from 'rxjs';
import { Tipologia, TipologiasInterface } from 'app/models/tipologias.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { DataFichaRegistro, FichaRegistro } from 'app/models/fichaRegistro.model';

@Component({
    selector: 'informacion-tecnica',
    templateUrl: 'informacion-tecnica.component.html',
    imports: [
        MatButtonModule, FormsModule, MatFormFieldModule, MatSelectModule, CommonModule
    ]
})

export class InformaciónTecnicaComponent implements OnInit {
    informacionTecnica:InfoTecnicaBienMueble= new InfoTecnicaBienMueble
    servicios$:Observable<Tipologia[]>
    valores$:Observable<Tipologia[]>
    informacionFichaRegistro$:Observable<DataFichaRegistro>
    uu_id:string
    serviciosSeleccionados: Tipologia[] = [];
    serviciosDisponibles: Tipologia[] = [];
    valoresSeleccionados: Tipologia[]=[]
    valoresDisponibles: Tipologia[]=[]

    serviciosSubscription: Subscription;
    fichaRegistroSubscription: Subscription;
    valoresSubscription:Subscription


    constructor(
        private detalleBienesService:DetalleBienCulturalService, 
        private route:ActivatedRoute,
        private utilsService:UtilsService
    ) { 
        this.uu_id = this.route.snapshot.paramMap.get('uu_id')!;
        this.servicios$= this.detalleBienesService.servicios$
        this.valores$= this.detalleBienesService.valor$
        this.informacionFichaRegistro$ = this.detalleBienesService.fichaRegisto$;
    }

    ngOnInit() {

        this.serviciosSubscription = this.servicios$.subscribe(servicios => {
            this.serviciosDisponibles = servicios;
        });

        this.valoresSubscription = this.valores$.subscribe(valores => {
            this.valoresDisponibles = valores;
        });
       
        this.fichaRegistroSubscription = this.informacionFichaRegistro$.subscribe(ficha => {
                const info = ficha.bienCultural;

                this.informacionTecnica = {
                    alto: info.alto,
                    ancho: info.ancho,
                    largo: info.largo,
                    Grosor: info.grosor,
                    Diametro: info.diametro,
                    area: info.area,
                    profundidad: info.profundidad,
                    Servicio: info.servicio,
                    Valor: info.valor,
                    material: info.materiales,
                    tecnica: info.tecnicas,
                    utileria: info.utileria ?? ''
                };

            const servicioRaw = info.servicio;
            if (servicioRaw && this.serviciosDisponibles.length > 0) {
            const matches = [...servicioRaw.matchAll(/\((\d+),([^)]+)\)/g)];
            this.serviciosSeleccionados = matches.map(match => {
                const id = Number(match[1]);
                return this.serviciosDisponibles.find(s => s.tipologiaId === id)!;
            }).filter(Boolean);
            }

            const valorRaw = info.valor;
            if (valorRaw && this.valoresDisponibles.length > 0) {
                const matches = [...valorRaw.matchAll(/\((\d+),([^)]+)\)/g)];
                this.valoresSeleccionados = matches.map(match => {
                const id = Number(match[1]);
                return this.valoresDisponibles.find(v => v.tipologiaId === id)!;
                }).filter(Boolean);
            }
        });
    }

    actualizarInformacion(){
        this.detalleBienesService.actualizarInformacionTecnica(this.informacionTecnica, this.uu_id)
        .then(response=>{
            this.utilsService.openSuccessSnakBar('Se ha actualizado la información correctamente.')
            this.detalleBienesService.getBitacoraBienes(this.uu_id)
        })
    }

    onSelectionChange(type: string, selectedItems: Tipologia[]) {
        if (type === 'servicio') {
            this.serviciosSeleccionados = selectedItems;
            this.informacionTecnica.Servicio = selectedItems
                .map(s => `(${s.tipologiaId},${s.descripcion})`)
                .join('-');
        } else if (type === 'valor') {
            this.valoresSeleccionados = selectedItems;
            this.informacionTecnica.Valor = selectedItems
                .map(s => `(${s.tipologiaId},${s.descripcion})`)
                .join('-');
        }
    }
    
    
    ngOnDestroy() {

        if (this.serviciosSubscription) {
        this.serviciosSubscription.unsubscribe();
        }
        if (this.fichaRegistroSubscription) {
        this.fichaRegistroSubscription.unsubscribe();
        }
        if (this.valoresSubscription) {
        this.valoresSubscription.unsubscribe();
        }
    }

}